module.exports = __webpack_public_path__ + "img/057.e86ab227.png";